import {
  getQuery as udasGetQuery,
  insertQuery as udasInsertQuery,
  updateQuery as udasUpdateQuery,
  deleteQuery as udasDeleteQuery
} from "./UdasWrapper";
import { addErrorLog } from "../Logger/logger";
import { cacheUpdateSocketIoClient } from '../App';

export const insertCredential = async (input) => {
  const data = JSON.stringify({
    query: `mutation InsertUserCredentials($tenantId: String!, $credentials: JSON) {
  insertUserCredentials(tenant_id: $tenantId, credentials: $credentials) {
    isSuccessful
    message
    resultObject
  }
}`,
    variables: input
  });

  try {
    return (await udasInsertQuery(data))?.insertUserCredentials;
  } catch (error) {
    addErrorLog("mutation InsertCredentials", error, input.tenantId);
    return null;
  }
};

export const updateCredential = async (input) => {
  try {
    if (cacheUpdateSocketIoClient?.connected) {
      cacheUpdateSocketIoClient.emit('credentialUpdate', input);
      console.debug(`Requested credential cache update in cxf-executor for credential ${input?.credentialId} (${input?.credential?.application?.name}) for tenant ${input?.tenantId}`);
    } else {
      console.error(`Unable to request connector cache update in cxf-executor because the service is not running or not reachable`);
      return null;
    }
  } catch (error) {
    console.error(`Unable to request credential cache update in cxf-executor: ${JSON.stringify(error)}`);
  }

  const data = JSON.stringify({
    query: `mutation UpdateUserCredentialsById($credentialsId: ID!, $tenantId: String!, $credential: JSON) {
  updateUserCredentialsById(credentials_id: $credentialsId, tenant_id: $tenantId, credential: $credential) {
    isSuccessful
    message
    resultObject
  }
}`,
    variables: {
      credentialsId: input.credentialId,
      tenantId: input.tenantId,
      credential: input.credential
    }
  });
  try {
    return (await udasUpdateQuery(data))?.updateUserCredentialsById;
  } catch (error) {
    addErrorLog("mutation UpdateCredentialsById", error.input.tenantId);
    return null;
  }
};

export const deleteCredential = async (input) => {
  const data = JSON.stringify({
    query: `mutation DeleteUserCredentials($credentialsId: String!, $tenantId: String!) {
  deleteUserCredentials(credentials_id: $credentialsId, tenant_id: $tenantId) {
    isSuccessful
    message
    resultObject
  }
}`,
    variables: { credentialsId: input.credentialId, tenantId: input.tenantId }
  });
  try {
    const response = await udasDeleteQuery(data);
    return response?.deleteUserCredentials;
  } catch (error) {
    addErrorLog("mutation DeleteCredentials", error, input.tenantId);
    return null;
  }
};

export const getCredentialById = async (tenant_id, credential_id) => {
  try {
    const data = JSON.stringify({
      query: `query GetUserCredentialsById($getUserCredentialsByIdId: ID!, $tenantId: String!) {
        getUserCredentialsById(id: $getUserCredentialsByIdId, tenant_id: $tenantId) {
          isSuccessful
          message
          resultObject
        }
      }`,
      variables: {
        getUserCredentialsByIdId: credential_id,
        tenantId: tenant_id
      }
    });
    const response = await udasGetQuery(data);
    return response?.getUserCredentialsById;
  } catch (error) {
    addErrorLog("query GetUserCredentialsById", error, tenant_id);
    return null;
  }
};

export const unshareCredential = async (tenant_id, credential_id, credential, usersToUnshare) => {
  try {
    const data = JSON.stringify({
      query: `mutation UnshareCredentials($tenantId: String!, $credentialId: String!, $userIds: [String], $credential: JSON) {
  unshareCredentials(tenant_id: $tenantId, credential_id: $credentialId, user_ids: $userIds, credential: $credential) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        tenantId: tenant_id,
        credentialId: credential_id,
        credential: credential,
        userIds: usersToUnshare
      }
    });
    
    return (await udasUpdateQuery(data))?.unshareCredentials;
  } catch (error) {
    addErrorLog("mutation UnshareCredentials", error, tenant_id);
    return null;
  }
};

export const shareCredential = async (input) => {
  try {
    const data = JSON.stringify({
      query: `mutation ShareCredentials($tenantId: String!, $users: [JSON], $credential: JSON!) {
  shareCredentials(tenant_id: $tenantId, users: $users, credential: $credential) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        users: input.users,
        tenantId: input.tenantId,
        credential: input.credential
      }
    });
    
    return (await udasUpdateQuery(data))?.shareCredentials;
  } catch (error) {
    addErrorLog("mutation ShareCredentials", error, input.tenant_id);
    return null;
  }
};

export const getTenantCredentials = async (tenant_id, user_id) => {
  try {
    const data = JSON.stringify({
      query: `query GetTenantCredentials($tenant_id: String!, $user_id: String) {
        getTenantCredentials(tenant_id: $tenant_id, user_id: $user_id) {
          isSuccessful
          message
          resultObject
        }
      }`,
      variables: {
        tenant_id,
        user_id
      }
    });
    const response = await udasGetQuery(data);

    return response?.getTenantCredentials;
  } catch (error) {
    addErrorLog("query getTenantCredentials", error, tenant_id);
    return null;
  }
};
